import React, { useContext } from "react";

import {
  ModalContainer,
  ModalContainerBodyContainer,
  ModalContainerBody,
} from "./styled";

import { CoreContext } from "context/CoreContext";
import ModalFinishCampaign from "../FinishCampaign";

export default function ModalFinish() {
  const { modal, setModal } = useContext(CoreContext);

  const close = () => {
    setModal(null);
  };

  return (
    <>
      <ModalContainer>
        <ModalContainerBodyContainer>
          <ModalContainerBody>
            <ModalFinishCampaign
              closeable={close}
              campaign={modal?.item?.campaign}
              reload={modal?.reload}
            />
          </ModalContainerBody>
        </ModalContainerBodyContainer>
      </ModalContainer>
    </>
  );
}
